export enum TemplatesRoles {
  VIEWER = 'roles.templatesViewer',
  COLLECTION_MANAGER = 'roles.templatesCollectionManager',
  PERSISTER = 'roles.templatesPersister',
  DELETER = 'roles.templatesDeleter',
  PROPOSAL_TEMPLATES_USER = 'roles.proposalTemplatesUser',
}
